var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPaperclip = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.6 90.8c14.249 0 25.8-11.551 25.8-25.8S95.849 39.2 81.6 39.2 55.8 50.751 55.8 65s11.551 25.8 25.8 25.8z",
    fill: "#FFCBBD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 45.6l-4.9-10.5S54 23.6 40.7 29.2M44.9 83.1L29 49.1s-5.5-11.3 7.3-17.9M48.9 91.6l3.4 7.4s5.1 12.1 15.1 7.5M71.4 81.1l3.4 7.4s6 11.7-3.9 16.4M56.6 88L45.4 64",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8 84L56.4 48.9c-4.3-9.2-11.3-4.7-11.3-4.7s-7.8 2.5-3.5 11.6l1.7 3.7 3.4 7.4",
    stroke: "#311D6C",
    strokeWidth: 2.105,
    strokeLinecap: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPaperclip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/paperclip.36965746f11338855cfeca185feddedb.svg";